module.exports = __webpack_public_path__ + "img/icons_connect-wh.a64e1dff.svg";